import { types } from "../types/types";

const initialState = {
  openSidebar: {},
};

export const openSidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.openSideBar:
      return {
        ...state,
        openSidebar: { ...action.payload },
      };
    case types.authLogout:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
